import { CountryProvinceSelector } from '@shopify/theme-addresses';

const countryProvinceSelector = new CountryProvinceSelector(window.theme.filteredCountryTags || window.theme.allCountryOptionTags);

window.initialiseProvinceSwitchers = () => {
  const addressForms = document.querySelectorAll('[data-address-form]');

  Array.from(addressForms).forEach(form => {
    const countryInput = form.querySelector('[data-address-country]');
    const provinceInput = form.querySelector('[data-address-province]');

    countryProvinceSelector.build(
      countryInput, 
      provinceInput, 
      {
        onCountryChange: (provinces, countryNodeElement, provincesNodeElement) => {
          provinceInput.classList.toggle('d-none', !provinces.length);
        },
      }
    );

    const currentCountry = countryInput.value;
    if (currentCountry) {
      return;
    }

    // Fallback default
    // try {
    //   const defaultCountry = countryInput.dataset.default;
    //   const defaultOption = countryInput.querySelector(`[data-value="${ defaultCountry }"]`);
    //   const defaultValue = defaultOption.value;
    //   countryInput.value = defaultValue;
    //   countryInput.dispatchEvent(new Event('change'));
    // } catch(error) {
    //   console.error('Error while setting default country option', error);
    // }
  });
}

window.addEventListener('load', function() {
  initialiseProvinceSwitchers();
});
